// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10i6E","col":"styles_col__1ZAjb"};